import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addUserMessage, messagesSelectors } from 'store/messages'
import { createUserMessage } from 'utils/helpers'
import { askBotAnswer } from 'api/index'

export const useSendBotQuestion = () => {
  const dispatch = useDispatch()
  const [sending, setSending] = useState(false)
  const chatId = useSelector(messagesSelectors.chatId)
  const botTyping = useSelector(messagesSelectors.botTyping)

  const sendQuestion = useCallback(
    async (question: string) => {
      if (sending || botTyping || !chatId) return
      try {
        setSending(true)
        const { message, _id: questionId, senderId, chatSenderRole } = createUserMessage(question)
        dispatch(addUserMessage({ chatId, _id: questionId, message, senderId, chatSenderRole }))
        await askBotAnswer({ question, questionId })
      } catch (e) {
        console.error({ e })
      } finally {
        setSending(false)
      }
    },
    [dispatch, sending, botTyping, chatId],
  )

  return { sendQuestion, sending, botTyping }
}
